module.exports = __webpack_public_path__ + "media/images/ALD_subscriber_viewer_sm_playbook-444dcf1b.png";